'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

const getSupportedTypes = _ref => {
  var _orderItem$eligibilit, _stepsProps$exchanges, _orderItem$eligibilit2, _orderItem$eligibilit3;
  let {
    orderItem,
    stepsProps
  } = _ref;
  const returnEnabled = !!((_orderItem$eligibilit = orderItem.eligibilities.return) !== null && _orderItem$eligibilit !== void 0 && _orderItem$eligibilit.isEligible);
  const exchangeEnabled = !!(stepsProps !== null && stepsProps !== void 0 && (_stepsProps$exchanges = stepsProps.exchanges) !== null && _stepsProps$exchanges !== void 0 && _stepsProps$exchanges.enabled) && !!((_orderItem$eligibilit2 = orderItem.eligibilities.exchange) !== null && _orderItem$eligibilit2 !== void 0 && _orderItem$eligibilit2.isEligible);
  const claimEnabled = !!orderItem.hasShippingProtection || !!((_orderItem$eligibilit3 = orderItem.eligibilities.claims) !== null && _orderItem$eligibilit3 !== void 0 && _orderItem$eligibilit3.isEligible);
  const noNonReturnTypes = !(exchangeEnabled || claimEnabled);
  return {
    return: returnEnabled,
    exchange: exchangeEnabled,
    claim: claimEnabled,
    defaultType: returnEnabled && noNonReturnTypes ? 'return' : undefined
  };
};
const useReturnReasonsFormData = _ref2 => {
  let {
    orderItem,
    selectedItem,
    stepsProps,
    defaultType
  } = _ref2;
  defaultType = defaultType ?? getSupportedTypes({
    orderItem,
    stepsProps
  }).defaultType;
  const initialValues = React.useMemo(() => {
    var _orderItem$availableR, _selectedItem$exchang;
    return {
      type: selectedItem !== null && selectedItem !== void 0 && selectedItem.exchangeTo ? 'exchange' : selectedItem ? 'return' : defaultType,
      selection: selectedItem ? [(_orderItem$availableR = orderItem.availableReasons) === null || _orderItem$availableR === void 0 ? void 0 : _orderItem$availableR.find(reason => reason.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.reason.id))].filter(e => e) : [],
      quantity: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.quantity) ?? (orderItem.remainingQuantity === 1 ? 1 : undefined),
      pictures: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.pictures,
      customerComments: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.customerComments) ?? '',
      attested: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.attested) ?? false,
      exchangeSelections: selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem$exchang = selectedItem.exchangeTo) === null || _selectedItem$exchang === void 0 ? void 0 : _selectedItem$exchang.variantInfo,
      exchangeTo: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.exchangeTo
    };
  }, [selectedItem, orderItem, defaultType]);
  const [values, setValues] = React.useState(initialValues);
  const reset = React.useCallback(() => {
    setValues(initialValues);
  }, [initialValues]);
  const update = React.useCallback(updates => {
    const hasUpdate = Object.entries(updates).some(_ref3 => {
      let [key, newValue] = _ref3;
      return values[key] !== newValue;
    });
    if (hasUpdate) {
      const newValues = {
        ...values,
        ...updates
      };
      setValues(newValues);
      return newValues;
    }
    return values;
  }, [values]);
  return React.useMemo(() => ({
    values,
    update,
    reset
  }), [values, update, reset]);
};

exports.getSupportedTypes = getSupportedTypes;
exports.useReturnReasonsFormData = useReturnReasonsFormData;
